import { Type } from "src/utils";

/**
 * 表示一个体检状态订单。
 * @enum
 * @version 1.0.0
 */
enum CheckupOrderStatus
{
    /**
     * 取消
     * @member
     */
    CANCEL = 0,

    /**
     * 待支付
     * @member
     */
    UNPAID = 1,

    /**
     * 已支付 
     * @member
     */
    PAID = 2,

    /**
     * 已完成 
     * @member
     */
    COMPLETE = 3,

    // /**
    //  * 报告已上传 
    //  * @member
    //  */
    // REPORT = 4,

    // /**
    //  * 退款中
    //  * @member
    //  */
    // REFUND = 5,

    /**
     * 已退款 
     * @member
     */
    REFUNDED = 6,

    /**
     * 已失效 
     * @member
     */
    INVALID = 7
  
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(CheckupOrderStatus,
{
    CANCEL:
    {
        alias: "已取消",
        description: ""
    },
    UNPAID:
    {
        alias: "待支付",
        description: ""
    },
    PAID:
    {
        alias: "已支付",
        description: ""
    },
    COMPLETE:
    {
        alias: "已完成",
        description: ""
    },
    // REPORT:
    // {
    //     alias: "报告已上传",
    //     description: ""
    // },
    // REFUND:
    // {
    //     alias: "退款中",
    //     description: ""
    // },
    REFUNDED:
    {
        alias: "已退款",
        description: ""
    },
    INVALID:
    {
        alias: "已失效",
        description: ""
    }
});

export default CheckupOrderStatus;